import React from 'react';

import { Typography } from 'antd';
import styled from 'styled-components';

import { SWOT_COMPARISON_LABELS } from 'common/Widgets/constants';
import { useAppSelector } from 'store/hook';
import { getCommunityById } from 'utils/helpers/communityMap';

import { useEditSwotDataModalContext } from './EditSwotDataModalContext';

const Container = styled.div`
  display: flex;
  flex-flow: row;
  justify-content: right;
  margin-bottom: 20px;
`;

const InnerContainer = styled.div`
  display: flex;
  flex-flow: column;
  align-items: center;
  width: 380px;
`;

const StyledText = styled(Typography.Text)`
  width: 76px;
  font-size: 12px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
`;

const ComparisonTextContainer = styled.div`
  display: flex;
  flex-flow: column;
  justify-content: space-around;
  margin-bottom: 20px;
  height: 42px;
`;

const ComparisonText = styled(Typography.Text)`
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: var(--text-secondary);
`;

const ComparisonItemsContainer = styled.div`
  display: flex;
  flex-flow: row;
`;

const CategoriesHeader = () => {
  const { communityMap } = useAppSelector((state) => state.global);

  const { competitorId } = useEditSwotDataModalContext();

  const competitor = getCommunityById(communityMap, competitorId);
  const competitorName = competitor?.comunity_name ?? 'Unknown Competitor';

  return (
    <Container>
      <InnerContainer>
        <ComparisonTextContainer>
          <ComparisonText>
            In comparison to competitor <span style={{ color: 'var(--text-primary)' }}>{competitorName}</span>,
          </ComparisonText>
          <ComparisonText>
            <span style={{ color: 'var(--text-primary)' }}>My Community</span> is:
          </ComparisonText>
        </ComparisonTextContainer>
        <ComparisonItemsContainer>
          {Object.values(SWOT_COMPARISON_LABELS).map((label) => (
            <StyledText key={label}>{label}</StyledText>
          ))}
        </ComparisonItemsContainer>
      </InnerContainer>
    </Container>
  );
};

export default CategoriesHeader;
